import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import {
  Home,
  Users,
  CreditCard,
  BarChart3,
  LogOut,
  X,
  Plus,
  Smartphone,
  Globe,
} from 'lucide-react';
import '../../i18n';
import BRAND from '../../brand';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

export default function AdminSidebar({ sidebarOpen, setSidebarOpen, toggleLocale, locale }) {
  const location = useLocation();
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);
  const { t } = useTranslation();

  // Auto-close sidebar on mobile when route changes
  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    if (isMobile && sidebarOpen) {
      setSidebarOpen(false);
    }
  }, [location.pathname, setSidebarOpen, sidebarOpen]);

  const menuItems = [
    { icon: Home, label: t('Dashboard'), path: '/admin' },
    { icon: Users, label: t('Users'), path: '/admin/users' },
    { icon: Plus, label: t('Add Balance'), path: '/admin/add-balance' },
    { icon: CreditCard, label: t('Plans'), path: '/admin/plans' },
    { icon: Smartphone, label: t('Accounts'), path: '/admin/accounts' },
    { icon: BarChart3, label: t('Statistics'), path: '/admin/stats' },
  ];

  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };

  return (
    <div
      className={`sidebar-wrapper ${sidebarOpen ? 'open' : 'closed'} ${
        locale === 'ar' ? 'rtl' : 'ltr'
      }`}
    >
      {/* Close button for mobile */}
      <button
        className="sidebar-close-mobile"
        onClick={() => setSidebarOpen(false)}
      >
        <X size={24} />
      </button>

      {/* Logo */}
      <div className="sidebar-logo">
        <Link to="/admin" className="logo-link">
          <span className="logo-brand">{BRAND[i18n.language] || BRAND.en}</span>
          {sidebarOpen && <span className="logo-badge">Admin</span>}
        </Link>
      </div>

      {/* Navigation */}
      <nav className="sidebar-navigation">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${isActive ? 'active' : ''}`}
              title={!sidebarOpen ? item.label : ''}
            >
              <Icon size={20} />
              {sidebarOpen && <span className="nav-label">{item.label}</span>}
            </Link>
          );
        })}
      </nav>

      {/* Footer Section */}
      <div className="sidebar-footer">
        {/* Language Toggle */}
        <button
          className="sidebar-footer-btn lang-toggle"
          onClick={toggleLocale}
          title={t('Toggle language')}
        >
          <Globe size={18} />
          {sidebarOpen && <span>{locale === 'ar' ? 'EN' : 'AR'}</span>}
        </button>

        {/* User Card */}
        {sidebarOpen && (
          <div className="user-card">
            <div className="user-avatar">
              {user?.first_name?.charAt(0).toUpperCase() || 'A'}
            </div>
            <div className="user-info">
              <p className="user-name">
                {user?.first_name} {user?.last_name}
              </p>
              <p className="user-role">{t('Admin')}</p>
            </div>
          </div>
        )}

        {/* Logout Button */}
        <button
          className="sidebar-footer-btn logout-btn"
          onClick={handleLogout}
          title={t('Sign Out')}
        >
          <LogOut size={18} />
          {sidebarOpen && <span>{t('Sign Out')}</span>}
        </button>
      </div>
    </div>
  );
}
